import { render, staticRenderFns } from "./TokenLoginView.vue?vue&type=template&id=72e1e03c&scoped=true"
import script from "./TokenLoginView.vue?vue&type=script&lang=js"
export * from "./TokenLoginView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72e1e03c",
  null
  
)

export default component.exports